/**
 * Newsletter Signup — AJAX form submission
 * Posts to the configured action endpoint (e.g. Mailchimp POST URL).
 * Shows success / error message in .newsletter__feedback
 */
(function () {
  'use strict';

  function showFeedback(feedbackEl, message, isError) {
    feedbackEl.textContent = message;
    feedbackEl.className   = 'newsletter__feedback alert-inline ' + (isError ? 'alert-inline--error' : 'alert-inline--success');
  }

  function initForm(form) {
    var feedbackEl = form.querySelector('.newsletter__feedback');
    var submitBtn  = form.querySelector('[type="submit"]');
    var action     = form.getAttribute('action');

    if (!feedbackEl || !action) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = form.querySelector('input[name="email"]');
      if (!email || !email.value) return;

      // Disable while submitting
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }
      feedbackEl.textContent = '';
      feedbackEl.className   = 'newsletter__feedback';

      var body = new FormData();
      body.append('email', email.value);

      // Append any hidden fields
      form.querySelectorAll('input[type="hidden"]').forEach(function (hidden) {
        body.append(hidden.name, hidden.value);
      });

      fetch(action, {
        method: 'POST',
        body:   body,
        headers: { 'Accept': 'application/json' },
      })
        .then(function (res) {
          if (res.ok) {
            return res.json().catch(function () { return { ok: true }; });
          }
          return res.json().catch(function () { return { ok: false }; });
        })
        .then(function (data) {
          // Mailchimp returns { result: 'success' } or { result: 'error', msg: '...' }
          var success = data.result === 'success' || data.ok === true || data.status === 'success';
          if (success) {
            showFeedback(feedbackEl, data.msg || 'Thanks for subscribing!', false);
            form.reset();
          } else {
            var msg = data.msg || data.message || 'Something went wrong. Please try again.';
            // Mailchimp sometimes includes an HTML anchor in the error — strip it
            msg = msg.replace(/<[^>]*>/g, '');
            showFeedback(feedbackEl, msg, true);
          }
        })
        .catch(function () {
          showFeedback(feedbackEl, 'Network error. Please try again.', true);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-newsletter="1"]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
